import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=1290856e&scoped=true&"
import script from "./tag.vue?vue&type=script&scoped=true&lang=js&"
export * from "./tag.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&id=1290856e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1290856e",
  null
  
)

export default component.exports